export type ReportRoute = {
  label: string;
  title: string;
  url: string;
  pages: { label: string; value: string }[];
};

export const reportRoutes: Record<string, ReportRoute> = {
  'market-reports': {
    label: 'Market Reports',
    title: 'Unlock MLS MarketReports',
    url: 'https://lookerstudio.google.com/embed/reporting/6fa8b053-b109-4183-a4c5-8c9185fb2f2a/page/p_fnf3gdsnvc?params=%7B%22df414%22:%22include%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580Unlock%22%7D',
    pages: [
      { label: 'Monthly Sales & Pricing', value: 'p_fnf3gdsnvc' },
      { label: 'Monthly Buyer Demand', value: 'p_7trgzxwx5c' },
      { label: 'Monthly Inventory', value: 'p_tm0o6hnt8c' },
      { label: 'Monthly Price Drops', value: 'p_btb4ar7ufd' },
      { label: 'Yearly Sales & Pricing', value: 'p_j30j7igq5c' },
      { label: 'Yearly Buyer Demand', value: 'p_7ytsm8gs5c' },
      { label: 'Weekly/YTD Sales', value: 'p_wzb759onvc' },
      { label: 'Weekly Inventory', value: 'p_b7m74kpued' },
      { label: 'Cities', value: 'p_wu7xju1ahd' },
      { label: 'By Beds / Price Range', value: 'p_8cwbrlx11c' },
      { label: 'Tables / MTD', value: 'p_7nuw0r8hvc' },
      {
        label: 'Monthly Sales & Pricing: Austin / Single Family Residence',
        value:
          'p_fnf3gdsnvc?params=%7B"df369":"include%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580Austin","df368":"include%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580Single%2520Family%2520Residence"%7D',
      },
    ],
  },
  'rental-reports': {
    label: 'Rental Reports',
    title: 'Unlock MLS RentalReports',
    url: 'https://lookerstudio.google.com/embed/reporting/706e6ffa-ffe1-4458-8d8d-f5d0c1abe461/page/p_fnf3gdsnvc?params=%7B%22df514%22:%22include%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580Unlock%22%7D',
    pages: [
      { label: 'Monthly Activity & Pricing', value: 'p_fnf3gdsnvc' },
      { label: 'Monthly Rental Demand', value: 'p_7trgzxwx5c' },
      { label: 'Monthly Inventory', value: 'p_cb5c3mv4ed' },
      { label: 'Yearly Activity & Pricing', value: 'p_j30j7igq5c' },
      { label: 'Yearly Rental Demand', value: 'p_7ytsm8gs5c' },
      { label: 'Weekly Leasing Activity', value: 'p_wzb759onvc' },
      { label: 'Weekly Inventory', value: 'p_b7m74kpued' },
      { label: 'Tables / MTD', value: 'p_mvfgnulold' },
      { label: 'Cities', value: 'p_blkyn2m09c' },
      { label: 'By Beds / Price Range', value: 'p_8cwbrlx11c' },
    ],
  },
  'comparison-reports': {
    label: 'Comparison Reports',
    title: 'Unlock MLS ComparisonReports',
    url: 'https://lookerstudio.google.com/embed/reporting/b80e34b5-9369-4b00-92ca-9c0e2813b639/page/p_7trgzxwx5c?params=%7B%22df210%22:%22include%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580Unlock%22%7D',
    pages: [
      { label: 'Counties', value: 'p_7trgzxwx5c' },
      { label: 'Counties: Table', value: 'p_cy1phxk1ed' },
      { label: 'Cities', value: 'p_prgoc4d1ed' },
      { label: 'Cities: Table', value: 'p_67d5yk86ed' },
      { label: 'Zip Codes', value: 'p_8v8sj9d1ed' },
      { label: 'Zip Codes: Table', value: 'p_86uqko86ed' },
      { label: 'Price Ranges', value: 'p_m3t4ds86ed' },
      { label: 'Months of Supply', value: 'p_blkyn2m09c' },
      { label: 'Heat Maps', value: 'p_ypawhia7ed' },
    ],
  },
  'land-reports': {
    label: 'Land Reports',
    title: 'Unlock MLS LandReports',
    url: 'https://lookerstudio.google.com/embed/reporting/0ca3a5bc-132d-48dd-a0a6-400df4554227/page/p_fnf3gdsnvc?params=%7B%22df339%22:%22include%25EE%2580%25800%25EE%2580%2580IN%25EE%2580%2580Unlock%22%7D',
    pages: [
      { label: 'Monthly Sales & Pricing', value: 'p_fnf3gdsnvc' },
      { label: 'Monthly Buyer Demand', value: 'p_7trgzxwx5c' },
      { label: 'Monthly Inventory', value: 'p_tm0o6hnt8c' },
      { label: 'Yearly Sales & Pricing', value: 'p_j30j7igq5c' },
      { label: 'Yearly Buyer Demand', value: 'p_7ytsm8gs5c' },
      { label: 'Weekly Sales & Demand', value: 'p_wzb759onvc' },
      { label: 'Weekly Inventory', value: 'p_b7m74kpued' },
      { label: 'Tables', value: 'p_7nuw0r8hvc' },
    ],
  }
};
